export const HOWDENS_FOOTER =
  '*Dependent on the timescale of bespoke products (such as Template & Fit solid work surfaces and Paint to Order kitchens), delivery may be in stages. Confirming delivery is indicative of receiving the initial delivery only.';
